export const SOURCE_LOCAL = "local";

export const CLIENT_CURRENT_DATETIME_HEADER_KEY = "clientCurrentDateTime";